/* VAToolbox core theme.js — section loader, cart, predictive search, lazy media */
(function () {
  'use strict';

  // ---- Section loader: re-render sections when Shopify theme editor signals changes
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      // Section markup is replaced by Shopify; rebind any JS controllers
      bindControllers(e.target);
    });
  }

  // ---- Cart drawer (fetch-based, no full page reload)
  const cartDrawer = {
    el: null,
    overlay: null,
    open() {
      if (this.el) this.el.setAttribute('open', '');
      if (this.overlay) this.overlay.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    },
    close() {
      if (this.el) this.el.removeAttribute('open');
      if (this.overlay) this.overlay.removeAttribute('open');
      document.body.style.overflow = '';
    },
    async refresh() {
      if (!this.el) return;
      try {
        const res = await fetch('/?sections=cart-drawer');
        const data = await res.json();
        if (data['cart-drawer']) {
          this.el.innerHTML = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('.cart-drawer').innerHTML;
        }
      } catch (err) {
        console.error('cart refresh failed', err);
      }
    }
  };

  async function addToCart(form) {
    const formData = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        const msg = err.description || err.message || `Add to cart failed (HTTP ${res.status})`;
        console.error('[cart/add]', res.status, err);
        throw new Error(msg);
      }
      await cartDrawer.refresh();
      cartDrawer.open();
    } catch (err) {
      console.error('[addToCart]', err);
      alert(err.message);
    }
  }

  // ---- Predictive search (debounced)
  function debounce(fn, ms) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  }

  function bindPredictiveSearch(root) {
    const inputs = root.querySelectorAll('input[data-predictive-search]');
    inputs.forEach((input) => {
      const results = input.parentElement.querySelector('[data-predictive-results]');
      if (!results) return;
      const handler = debounce(async () => {
        const q = input.value.trim();
        if (!q) { results.innerHTML = ''; return; }
        try {
          const res = await fetch(`/search/suggest?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`);
          if (!res.ok) return;
          const html = await res.text();
          const dom = new DOMParser().parseFromString(html, 'text/html');
          const section = dom.querySelector('[data-predictive-results-inner]');
          if (section) results.innerHTML = section.innerHTML;
        } catch (err) {
          console.error('search failed', err);
        }
      }, 250);
      input.addEventListener('input', handler);
    });
  }

  // ---- Lazy media via IntersectionObserver
  function bindLazyMedia(root) {
    const els = root.querySelectorAll('img[loading="lazy"], iframe[loading="lazy"]');
    if (!('IntersectionObserver' in window) || !els.length) return;
    // Browsers handle loading=lazy natively; this is a fallback hook for any custom lazy targets.
  }

  // ---- Generic controllers binder
  function bindControllers(root) {
    // cart drawer triggers
    root.querySelectorAll('[data-cart-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => cartDrawer.open());
    });
    root.querySelectorAll('[data-cart-close]').forEach((btn) => {
      btn.addEventListener('click', () => cartDrawer.close());
    });
    // add to cart forms
    root.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(form); });
    });
    bindPredictiveSearch(root);
    bindLazyMedia(root);
  }

  // ---- Boot
  document.addEventListener('DOMContentLoaded', () => {
    cartDrawer.el = document.querySelector('.cart-drawer');
    cartDrawer.overlay = document.querySelector('.cart-drawer-overlay');
    if (cartDrawer.overlay) cartDrawer.overlay.addEventListener('click', () => cartDrawer.close());
    bindControllers(document);
  });

  // Expose for theme-specific scripts
  window.VAToolbox = window.VAToolbox || {};
  window.VAToolbox.cartDrawer = cartDrawer;
  window.VAToolbox.addToCart = addToCart;
})();
